/**
 * Small display helpers shared by the V2 gallery card and the V2
 * workspace preview. Reads only already-established content fields —
 * no new schema, no media API calls, no dependency on the legacy
 * authoring components.
 */
export function resolveSpreadThumbnailV2(content = {}) {
  const direct = [
    content.hero_url,
    content.hero_mobile_url,
    content.image_url,
    content.cover_url,
    content.photo_url,
  ];
  for (const url of direct) {
    if (typeof url === "string" && url.trim()) return url;
  }
  const macroMain = content.macro?.main_image?.url;
  if (typeof macroMain === "string" && macroMain.trim()) return macroMain;

  const macroMobile = content.macro?.mobile_image?.url;
  if (typeof macroMobile === "string" && macroMobile.trim()) return macroMobile;

  const sensoryMain = content.macro_sensory?.main_image?.url;
  if (typeof sensoryMain === "string" && sensoryMain.trim()) return sensoryMain;

  const sensoryMobile = content.macro_sensory?.mobile_image?.url;
  if (typeof sensoryMobile === "string" && sensoryMobile.trim()) return sensoryMobile;

  const portraitMain = content.portrait_dialogue?.portrait?.url;
  if (typeof portraitMain === "string" && portraitMain.trim()) return portraitMain;

  const portraitMobile = content.portrait_dialogue?.mobile_portrait?.url;
  if (typeof portraitMobile === "string" && portraitMobile.trim()) return portraitMobile;

  const processMain = content.process_story?.main_image?.url;
  if (typeof processMain === "string" && processMain.trim()) return processMain;

  const processMobile = content.process_story?.mobile_image?.url;
  if (typeof processMobile === "string" && processMobile.trim()) return processMobile;

  const recipeHero = content.recipe?.hero?.url;
  if (typeof recipeHero === "string" && recipeHero.trim()) return recipeHero;

  const historical = content.historical_editorial || content.extra?.historical_editorial;
  const historicalMain = historical?.main_image?.url;
  if (typeof historicalMain === "string" && historicalMain.trim()) return historicalMain;

  const historicalMobile = historical?.mobile_image?.url;
  if (typeof historicalMobile === "string" && historicalMobile.trim()) return historicalMobile;

  const knowledge = content.extra?.knowledge;
  const knowledgeImage = knowledge?.image?.url;
  if (typeof knowledgeImage === "string" && knowledgeImage.trim()) return knowledgeImage;

  const videoMaster = content.extra?.video_master;
  const videoPoster = videoMaster?.poster?.url;
  if (typeof videoPoster === "string" && videoPoster.trim()) return videoPoster;

  if (Array.isArray(content.images) && content.images.length) {
    const url = content.images[0]?.url;
    if (typeof url === "string" && url.trim()) return url;
  }

  if (Array.isArray(content.media) && content.media.length) {
    const first = content.media[0];
    const url = first?.file_url || first?.url;
    if (typeof url === "string" && url.trim()) return url;
  }
  if (Array.isArray(content.photos) && content.photos.length) {
    const first = content.photos[0];
    const url = typeof first === "string" ? first : (first?.file_url || first?.url);
    if (typeof url === "string" && url.trim()) return url;
  }
  return null;
}
